export { default } from './ProductsSearch'
